export class FeeSummary{
    createDate?:Date;
    lastUpdate?:Date;
    uploadInProgress:boolean = false;
    isLastUploadSuccess?:boolean;
    uploadErrorMessage:string = '';
    submittedForDelete:boolean = false;
}